"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _decorators = require("decorators");

var _AccountList = babelHelpers.interopRequireWildcard(require("./AccountList"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var AccountGroupReportListItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(AccountGroupReportListItem, _Component);

  function AccountGroupReportListItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, AccountGroupReportListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(AccountGroupReportListItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(AccountGroupReportListItem, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "danger",
        overlay: "report"
      }, _react.default.createElement(_AccountList.Account, {
        account: this.item.account
      }), ' has made an abuse report on ', this.item.reply && _react.default.createElement(_AccountList.Account, {
        account: this.item.reply.account
      }), this.item.reply && "'s reply on ", this.item.comment && _react.default.createElement(_AccountList.Account, {
        account: this.item.comment.account
      }), this.item.comment && "'s ", this.item.comment && this.item.comment.type, this.item.comment && ' on ', _react.default.createElement("span", {
        className: "courseSession"
      }, this.item.catalogItem.title, " - ", this.item.courseSession.title), '.');
    }
  }], [{
    key: "notificationObject",
    value: function notificationObject(_ref) {
      var item = _ref.item;
      return Promise.all([_List.NotificationItem.notificationObject({
        item: item,
        overlayType: 'danger',
        overlay: 'report'
      })]).then(function (_ref2) {
        var _ref3 = babelHelpers.slicedToArray(_ref2, 1),
            notificationObject = _ref3[0];

        return Object.assign(notificationObject, {
          body: [item.account.name, 'has made an abuse report on', item.reply ? "".concat(item.reply.account.name, "'s reply on") : '', item.comment ? "".concat(item.comment.account.name, "'s ").concat(item.comment.type, " on") : '', item.catalogItem.title, '-', item.courseSession.title + '.'].join(' ').split(/\s+/g).filter(function (v) {
            return !!v;
          }).join(' ')
        });
      });
    }
  }]);
  return AccountGroupReportListItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = AccountGroupReportListItem;